import type { TenantThemeDefinition } from "../../core/types.ts";
import { biblTenantApps } from "./apps.ts";
import { biblTenantBase } from "./base.ts";

export const biblTenantTheme = {
  id: "bibl",
  brandId: "bibl",
  label: "BIBL",
  description: "BIBL 与 IFA 当前共用的默认风格预设。",
  base: biblTenantBase,
  apps: biblTenantApps,
} satisfies TenantThemeDefinition;

